import _ from 'classnames';
import React, { useRef } from 'react';
import { useWidth } from "../../hooks/useWidth.js";
import { DataGridHeaderCell } from "../DataGridHeaderCell/DataGridHeaderCell.js";
import styles from "./StickyDataGridHeaderCell.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StickyDataGridHeaderCell({
  isSticking,
  calculatedTop,
  nextButton,
  ...props
}) {
  const ref = useRef(null);
  const width = useWidth(ref);
  return /*#__PURE__*/_jsxs("div", {
    className: _(styles.stickyDataGridHeaderCell, {
      [styles.isFixedRight]: props.isFixedRight,
      [styles.hasBody]: props.hasBody,
      [styles.isLast]: props.isLast,
      [styles.isLastButOne]: props.isLastButOne
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: _(styles.normal, {
        [styles.isSticking]: isSticking
      }),
      ref: ref,
      children: [props.isFixedRight && !props.isLast && nextButton || props.isFixedRight && props.isLast && !props.hasBody && nextButton, /*#__PURE__*/_jsx(DataGridHeaderCell, {
        ...props
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: _(styles.fixed, {
        [styles.isSticking]: isSticking,
        [styles.isFixedRight]: props.isFixedRight,
        [styles.hasBody]: props.hasBody,
        [styles.isLast]: props.isLast,
        [styles.isLastButOne]: props.isLastButOne,
        [styles.isOverflowing]: props.isOverflowing,
        [styles.fullyScrolledLeft]: props.fullyScrolledLeft
      }),
      style: {
        top: calculatedTop,
        width
      },
      children: [props.isFixedRight && !props.isLast && nextButton || props.isFixedRight && props.isLast && !props.hasBody && nextButton, /*#__PURE__*/_jsx(DataGridHeaderCell, {
        ...props,
        isFixedRight: false
      })]
    })]
  });
}